export default function handleSetDocumentRequired(
  requiredOnShore: boolean,
  requiredOffShore: boolean
): string | undefined {
  if (requiredOnShore) return 'Required for BR';
  if (requiredOffShore) return 'Required for NON BR';
}
